import React from 'react';

import { CreateViolationDtoFormFieldEnum } from 'lib_api/lib/api/gen';

import { Input } from 'components/WrappedComponents';
import { FieldProps } from 'components/WrappedComponents/Form/FormWrapper/type';
import { useApi } from 'hooks/ApiStoreContext';
import { CreationCompteFormValues } from 'types/Compte/CreationCompte';
import { FormPlaceholders } from 'types/enums/FormPlaceholders';
import { CSSUtils } from 'utils/CSSUtils';

import {
  generateCreateUserRequestDtoFromFormData,
  validateCreateUserRequest,
} from '../utils';

function InputNom({
  values,
}: FieldProps<CreationCompteFormValues>): React.ReactElement {
  const cuController = useApi().ComptesUtilisateursControllerApi;
  const key: keyof CreationCompteFormValues = 'nom';

  return (
    <Input
      wrapperProps={{
        values: values,
        fieldKey: key,
        itemProps: {
          label: 'Nom',
          rules: [
            {
              required: true,
              validator: async (
                _rule,
                value: string | undefined,
              ): Promise<void> => {
                const requestObject = generateCreateUserRequestDtoFromFormData({
                  ...values,
                  nom: value === '' ? undefined : value,
                });

                return await validateCreateUserRequest(
                  cuController,
                  requestObject,
                  CreateViolationDtoFormFieldEnum.NOM,
                );
              },
            },
          ],
          labelCol: { span: CSSUtils.defaultLabelCol },
          wrapperCol: { span: CSSUtils.largeWrapperCol },
        },
      }}
      inputProps={{ placeholder: FormPlaceholders.Input }}
    />
  );
}

export default InputNom;
